import authTokenStorage from '@auth';
import { AUTH_TOKEN_STORAGE_KEYS } from '@auth/constants';


export default function authApi(fetch, baseUrl = '') {
  return {
    me() {
      return fetch.get(`${baseUrl}/admin/me`);
    },

    login({ username, password }) {
      return fetch.post(`${baseUrl}/login/admin`, {
        phoneNo: username,
        deviceId: localStorage.getItem(AUTH_TOKEN_STORAGE_KEYS.DEVICE_ID) || 'device_xyz_id',
        password
      });
    },
    
    loginWithGoogle({ googleToken }) {
      return fetch.post(`${baseUrl}/login/google`, {
        googleToken
      });
    },

    logout() {
      let promise = new Promise((resolve, reject) => {
        setTimeout(async () => {
          await authTokenStorage.removeAppToken();
          resolve('User logged out!');
          // reject('An error occurred!');
        }, 2000);
      });
      return promise;
    }
  };
}
